/**
 * Voice capture (audio recording → Whisper transcription) relies on an
 * OpenAI audio model. The self-hosted build runs against Ollama, which has
 * no audio transcription, so voice capture is turned off there.
 *
 * Set `VITE_VOICE_CAPTURE_DISABLED=1` to hide every microphone affordance
 * across the app. Defaults to enabled to preserve the hosted behaviour.
 */
export const VOICE_CAPTURE_ENABLED =
  import.meta.env.VITE_VOICE_CAPTURE_DISABLED !== "1";
